import companyService from '../service/company.service';

export const masterDataImportConfig = [
  {
    key: 'companyBank',
    title: 'Üzleti partner bankszámlaszám',
    templateFn: () => companyService.getCompanyBankExcelTemplate(),
    importFn: (files, userId) => companyService.importBankExcel(files, userId),
  },
];
